import React, { ReactElement, Component, useMemo } from "react";
import { injectIntl } from "react-intl";
import { Row, Col } from "antd";
import { Link, withRouter } from "react-router-dom";

const UseMenu = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const { formatMessage } = useMemo(() => props.intl, [props.intl]),
    menu_new: JSX.Element[] = useMemo((): JSX.Element[] => {
      const menu_new_new: JSX.Element[] = [];
      menu_new_new.push(
        <Col sm={24} className="mt-10" key="ingress">
          <Link to={`/ingress-info/ingress`}>
            <div className={`left_menu_button w-110 active text-left`}>{formatMessage({ id: "ingress_overview" })}</div>
          </Link>
        </Col>
      );
      return menu_new_new;
    }, [formatMessage]);

  return <Row>{menu_new}</Row>;
};

export default injectIntl(withRouter(UseMenu) as any);
